import { FC, PropsWithChildren, ReactNode } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { Title } from '@/shared/uikit/Title';
import { useModalsStore } from '@/widgets/modals/modals.store';

import { STYLES_PIN_BOTTOM } from '../styles';

type ModalContainerV4Props = PropsWithChildren & {
  title?: string;
  pinBottom?: boolean;
  icon?: ReactNode;
  iconBackground?: string;
};

export const ModalContainerV4: FC<ModalContainerV4Props> = ({
  title,
  pinBottom,
  icon,
  iconBackground,
  children,
}) => {
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();

  return (
    <StyledModal
      open={true}
      centered={isDesktop}
      footer={null}
      width={400}
      onCancel={modals.closeModal}
      style={pinBottom && !isDesktop ? STYLES_PIN_BOTTOM : {}}
    >
      <ModalBody>
        {icon && <IconContainer style={{ backgroundColor: iconBackground }}>{icon}</IconContainer>}
        {title && <Title level={3}>{title}</Title>}
        {children}
      </ModalBody>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      padding: 80px 24px 16px;
    }
  }
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.systemDark300};
`;

const IconContainer = styled.div`
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
